import ThemeEditor from "../ThemeEditor/ThemeEditor";

const OrgThemeEditor = () => {
  return <ThemeEditor from="org" />;
};

export default OrgThemeEditor;
